import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track if ID exists, we're in a browser, and it's not ReactSnap crawler
    const isReactSnap = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
    
    if (!GA_MEASUREMENT_ID || typeof window === 'undefined' || isReactSnap) return;

    // We use a small timeout to ensure react-helmet has time to update the <title>
    // before we send the page_view event to GA4.
    const handleRouteChange = () => {
      setTimeout(() => {
        if (window.gtag) {
          window.gtag('event', 'page_view', {
            page_path: location.pathname + location.search,
            page_title: document.title,
            page_location: window.location.href
          });
        }
      }, 100);
    };

    handleRouteChange();
  }, [location]);

  return null;
};

export default Analytics;
